import React, { ChangeEvent } from 'react';
import { Box, Text, Stack, Checkbox } from '@chakra-ui/core';
import { useTranslation } from 'react-i18next';
import { SearchAndSortTypes } from '../filters/seekersFiltersContextValueType';
import { useSeekersFilters } from '../filters/SeekersFiltersContext';
import { SearchAndSortProps } from './searchAndSortType';

export enum LanguageEvaluationStatus {
  EXPERT = 'EXPERT',
  COMPETENT = 'COMPETENT',
  LIMITED = 'LIMITED',
  OCCASIONAL = 'OCCASIONAL',
  NEEDS_REVIEW = 'NEEDS_REVIEW',
  TO_BE_ACCESSED = 'TO_BE_ACCESSED',
  REQUESTED = 'REQUESTED',
}
export const LanguageEvaluation = ({ tempSearchAndSortType, setTempSearchAndSortTypes }: SearchAndSortProps): JSX.Element => {
  const { t } = useTranslation('audioEvaluation');

  const { setIsFromSearchAndSort } = useSeekersFilters();

  const onHandleBackgroundCheck = (searchAndSort: SearchAndSortTypes) => {
    setIsFromSearchAndSort(true);
    setTempSearchAndSortTypes({ ...searchAndSort });
  };

  return (
    <Box>
      <Stack direction="column">
        {Object.values(LanguageEvaluationStatus).map((value) => (
          <Checkbox
            data-testid={`languageEvaluation_${value}`}
            key={`${value}`}
            isChecked={tempSearchAndSortType.languageEvaluation.includes(value.toLowerCase())}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              if (e.target.checked) {
                tempSearchAndSortType.languageEvaluation.push(value.toLowerCase());
              } else {
                const index = tempSearchAndSortType.languageEvaluation.indexOf(value.toLowerCase());
                tempSearchAndSortType.languageEvaluation.splice(index, 1);
              }
              onHandleBackgroundCheck(tempSearchAndSortType);
            }}
          >
            <Text
              px={3}
              style={{
                fontSize: '14px',
                fontWeight: 'normal',
              }}
            >
              {t(`status.${value}`)}
            </Text>
          </Checkbox>
        ))}
      </Stack>
    </Box>
  );
};
